import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceAreas from "./pages/ServiceAreas";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Accessibility from "./pages/Accessibility";
import Admin from "./pages/Admin";
import ScheduleTour from "./pages/ScheduleTour";
import JoinTeam from "./pages/JoinTeam";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Toaster position="top-center" richColors />
        <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/schedule-tour" element={<ScheduleTour />} />
          <Route path="/careers" element={<JoinTeam />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
